"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _carbonComponentsReact = require("carbon-components-react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LabelFactory = _interopRequireDefault(require("../../common/FormElement/LabelFactory"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.text-input {\n  width: 100%;\n  position: relative;\n  margin-bottom: 1.5rem; }\n  .text-input .bx--label {\n    color: #4c4c4c; }\n  .text-input .tooltip {\n    color: #a8a8a8; }\n  .text-input input[type='password']::-ms-reveal {\n    display: none; }\n  .text-input .icon {\n    position: absolute;\n    right: 17px;\n    bottom: 6px; }\n";
  const fileName = "TextInput_TextInput";
  const element = document.querySelector("style[data-sass-component='TextInput_TextInput']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const TextInput = props => {
  const customLabel = /*#__PURE__*/_react.default.createElement("div", null, props.label && _LabelFactory.default.create(props.label, props.required), props.tooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, props.tooltip));
  const onChange = event => {
    let value = event.target.value;
    if (props?.patterns?.length > 0) {
      const valueMatchAllPatterns = props.patterns.every(pattern => pattern.test(value));
      if (valueMatchAllPatterns) {
        props.onChange(event, value);
      }
      return;
    }
    props.onChange(event, value);
  };
  const carbonProps = {
    id: props.id,
    labelText: customLabel,
    name: props.id,
    onChange: onChange,
    placeholder: props.placeholder,
    helperText: props.helperText ? props.helperText : false,
    invalid: Boolean(props.invalidText),
    invalidText: props.invalidText ? props.invalidText : null,
    value: props.value,
    disabled: props.disabled,
    defaultValue: props.defaultValue,
    autoFocus: props.autoFocus,
    autoComplete: props.autoComplete,
    onKeyDown: props.onKeyDown
  };
  const element = props.password ? /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TextInput.PasswordInput, carbonProps) : /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.TextInput, carbonProps);
  const classes = ['text-input', props.className];
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.join(' '),
    onBlur: props.onBlur
  }, element, props.icon && /*#__PURE__*/_react.default.createElement("div", {
    className: 'icon',
    onClick: props.onIconClick ? props.onIconClick : null
  }, props.icon));
};
TextInput.propTypes = {
  id: _propTypes.default.string.isRequired,
  value: _propTypes.default.string,
  onChange: _propTypes.default.func.isRequired,
  label: _propTypes.default.string,
  required: _propTypes.default.bool,
  className: _propTypes.default.string,
  placeholder: function (props) {
    if (props.password && props.placeholder) {
      return new Error('Placeholder is not allowed for password fields.');
    }
  },
  helperText: _propTypes.default.string,
  invalidText: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.object,
  password: _propTypes.default.bool,
  type: _propTypes.default.string,
  onIconClick: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  defaultValue: _propTypes.default.string,
  autoFocus: _propTypes.default.bool,
  onKeyDown: _propTypes.default.func,
  tooltip: _propTypes.default.string,
  patterns: _propTypes.default.arrayOf(_propTypes.default.instanceOf(RegExp)),
  autoComplete: _propTypes.default.string
};
TextInput.defaultProps = {
  type: 'TextInput' // todo, https://stackoverflow.com/q/72446985/4840661
};
var _default = exports.default = TextInput;